interface ReceivingPaymentsEnvironment {
  VITE_ENV?: string;
  VITE_RECEIVING_PAYMENTS_ENABLED?: string;
}

// Receive payments (AB#5367) has no approved receiving setup in hosted Stage or Production yet, so its
// page, sidebar entry and Stripe return document stay dark there until it is switched on (AB#5865).
//
// This lives apart from featureFlags.ts because the isolated Stripe return document reads it: the
// default reads only these two settings, never the whole import.meta.env, so no other build setting
// (such as the analytics keys) reaches that document's bundle.
export const isReceivingPaymentsEnabled = (
  environment: ReceivingPaymentsEnvironment = {
    VITE_ENV: import.meta.env.VITE_ENV,
    VITE_RECEIVING_PAYMENTS_ENABLED: import.meta.env.VITE_RECEIVING_PAYMENTS_ENABLED,
  },
): boolean => {
  const configured = environment.VITE_RECEIVING_PAYMENTS_ENABLED?.trim().toLowerCase();
  if (configured === 'true') return true;
  if (configured === 'false') return false;

  const name = environment.VITE_ENV?.trim().toLowerCase();
  return name !== 'prod' && name !== 'stage';
};
